import {Injectable} from '@angular/core';
import {StorageService} from '../storage/storage.service';

@Injectable()
export class AuthenticationManager {
    private authenticate: any;
    private user: any;
    constructor(private storageService: StorageService) {
    }

    public getAuthenticate(): any {
        if (this.authenticate) {
            return this.authenticate;
        } else {
            return JSON.parse(localStorage.getItem('authentication'));
        }
    }

    public saveAuth(auth: any) {
        this.authenticate = auth;
        this.storageService.saveAuthenticate(auth);
    }

    public saveUser(user: any) {
        this.user = user;
        this.storageService.saveUser(user);
    }

    public getAuthenticatedUser() {
        if (this.user) {
            return this.user;
        } else {
            return JSON.parse(localStorage.getItem('currentUser'));
        }
    }

}
